<app-institucional-sidebar></app-institucional-sidebar>
<app-institucional-header></app-institucional-header>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
